import clipartBlockedAccess from 'images/user-blocked.png';
import React from 'react';
import { DEFAULT_ERROR_MESSAGE } from 'tracker.constants';
import MainView from '../main-view/main-view.component';
import WarningScreen from '../warning-screen/warning-screen.component';

export default () => (
  <MainView className="tracker-content">
    <WarningScreen
      illustration={clipartBlockedAccess}
      title={DEFAULT_ERROR_MESSAGE}
    />
  </MainView>
);
